function getLocale() {
  const locale = process.env.VUE_APP_LOCALITY;

  switch (locale) {
    case "es_es":
      return "es";
    case "it_it":
       return "it";
    case "en_uk":
      return "en";
    case "en_ie":
      return "ie";
  }
}

export default getLocale;
